(function () {
  // Main product form's own ATC button only — never touches ATC buttons in
  // other sections on the page (featured product, recommendations, etc.).
  const ATC_SELECTOR = 'button.ProductForm__AddToCart';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // ==========================================
  // MONEY FORMAT (matches the store's active currency / market)
  // ==========================================
  // window.cpbMoneySample is Liquid's own `money` output for 1,234,567.89
  // in the shopper's current currency (e.g. "£1,234,567.89", "Rs. 1,234,568",
  // "1.234.567,89 €"). We read the prefix, suffix, separators and decimals
  // from it, so every bundle price is formatted exactly like the theme's
  // own prices instead of a hardcoded "$".
  const moneyFormat = (function () {
    const fallback = { prefix: '£', suffix: '', thousands: ',', decimal: '.', decimals: 2 };
    const sample = String(window.cpbMoneySample || '').trim();
    const first = sample.search(/\d/);
    if (first === -1) return fallback;
    let last = sample.length - 1;
    while (last >= 0 && !/\d/.test(sample[last])) last--;

    const prefix = sample.slice(0, first);
    const suffix = sample.slice(last + 1);
    const numeric = sample.slice(first, last + 1);

    let decimals = 0;
    let decimal = '.';
    const decMatch = numeric.match(/([.,])(\d{2})$/);
    // "1,234,567.89" / "1.234.567,89" → 2 decimals. "1,234,568" → 0 decimals
    // (a 3-digit tail after the last separator is a thousands group, not decimals).
    if (decMatch) {
      decimals = 2;
      decimal = decMatch[1];
    }
    const intPart = decimals ? numeric.slice(0, -3) : numeric;
    const sepMatch = intPart.match(/\D/);
    const thousands = sepMatch ? sepMatch[0] : '';

    return { prefix, suffix, thousands, decimal, decimals };
  })();

  function formatMoney(amount) {
    const value = Number(amount) || 0;
    const fixed = value.toFixed(moneyFormat.decimals);
    const parts = fixed.split('.');
    const intWithSep = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, moneyFormat.thousands);
    const body = parts[1] ? intWithSep + moneyFormat.decimal + parts[1] : intWithSep;
    return moneyFormat.prefix + body + moneyFormat.suffix;
  }

  function initBuilder(root) {
    const grid = root.querySelector('[data-cpb-grid]');
    const countEl = root.querySelector('[data-cpb-count]');
    const pricePerItemEl = root.querySelector('[data-cpb-price-per-item]');
    // The builder is rendered inside the main product form — scope all ATC
    // logic to that form.
    const productForm = root.closest('form') || document;
    const productSection = root.closest('.shopify-section') || productForm;

    let quantity = 10;
    let activeSlotIndex = null;
    let selections = {};
    let currentSelectedSize = '';
    let currentCategoryHandle = '';
    let currentProducts = [];
    let isCustomPackActive = false;
    let isAdding = false;

    // ==========================================
    // MOVE DRAWER + OVERLAY TO <body>
    // ==========================================
    const drawerEl  = document.getElementById('bundle-drawer');
    const overlayEl = document.getElementById('bundle-drawer-overlay');
    const closeBtn  = document.getElementById('close-bundle-drawer');

    if (drawerEl && drawerEl.parentElement !== document.body) {
      document.body.appendChild(drawerEl);
    }
    if (overlayEl && overlayEl.parentElement !== document.body) {
      document.body.appendChild(overlayEl);
    }

    // ==========================================
    // FULL IMAGE VIEWER POPUP (all images of a drawer product)
    // ==========================================
    const imageViewerOverlay = document.getElementById('cpb-image-viewer-overlay');
    const imageViewerEl      = document.getElementById('cpb-image-viewer');
    const imageViewerTitle   = document.getElementById('cpb-image-viewer-title');
    const imageViewerGrid    = document.getElementById('cpb-image-viewer-grid');
    const imageViewerClose   = document.getElementById('cpb-image-viewer-close');

    // Appended to <body> after the drawer, so it stacks on top even though
    // both share the same max z-index (equal z-index paints in DOM order).
    if (imageViewerOverlay && imageViewerOverlay.parentElement !== document.body) {
      document.body.appendChild(imageViewerOverlay);
    }
    if (imageViewerEl && imageViewerEl.parentElement !== document.body) {
      document.body.appendChild(imageViewerEl);
    }

    function openImageViewer(title, images) {
      if (!imageViewerEl || !images || !images.length) return;
      if (imageViewerTitle) imageViewerTitle.textContent = title || '';
      if (imageViewerGrid) {
        imageViewerGrid.innerHTML = images
          .map(src => `<img src="${src}" alt="${title || ''}">`)
          .join('');
      }
      imageViewerEl.classList.add('active');
      imageViewerOverlay?.classList.add('active');
    }
    function closeImageViewer() {
      imageViewerEl?.classList.remove('active');
      imageViewerOverlay?.classList.remove('active');
    }
    imageViewerClose?.addEventListener('click', closeImageViewer);
    imageViewerOverlay?.addEventListener('click', closeImageViewer);

    function openBundleDrawer() {
      drawerEl?.classList.add('active');
      overlayEl?.classList.add('active');
      syncDrawerSizeWithProductPage();
    }

    // Carries whatever size is already selected up top into the drawer's own
    // size buttons, so the shopper doesn't have to pick a size again.
    function syncDrawerSizeWithProductPage() {
      const pageSize = (window.currentProductData && window.currentProductData.size) || currentSelectedSize;
      if (!pageSize) return;

      currentSelectedSize = pageSize;
      const drawerSizeButtons = drawerEl?.querySelectorAll('.drawer-size-btn');
      drawerSizeButtons?.forEach(function (b) {
        b.classList.toggle('active', b.dataset.size === pageSize);
      });
      const drawerSizeText = document.getElementById('drawer-selected-size-text');
      if (drawerSizeText) drawerSizeText.textContent = pageSize;

      if (currentCategoryHandle && currentProducts.length) renderDrawerProducts();
    }
    function closeBundleDrawer() {
      drawerEl?.classList.remove('active');
      overlayEl?.classList.remove('active');
    }
    closeBtn?.addEventListener('click', closeBundleDrawer);
    overlayEl?.addEventListener('click', closeBundleDrawer);

    // ==========================================
    // PAGE VARIANT (the size selected up top)
    // ==========================================
    function findVariantById(id) {
      if (!window.cpbProductVariants) return null;
      return window.cpbProductVariants.find(v => String(v.id) === String(id)) || null;
    }

    // Is the size currently selected on the main product page in stock?
    function isPageVariantAvailable() {
      const id = window.currentProductData && window.currentProductData.id;
      if (!id) return true;
      if (window.currentProductData.available !== undefined) return !!window.currentProductData.available;
      const v = findVariantById(id);
      return v ? !!v.available : true;
    }

    // ==========================================
    // ATC BUTTON + NOTIFY BUTTON
    // ==========================================
    // We own the button's contents while Custom Pack is active, so the
    // "Add to bag" text is always there (it was being hidden before), and
    // we re-run this after the theme's own variant-change code, which
    // rewrites the button's innerHTML on every size click.
    function getAtcButtons() {
      return productForm.querySelectorAll(ATC_SELECTOR);
    }
    function getNotifyButton() {
      return productSection.querySelector('.BIS_trigger');
    }
    function getAddLabel() {
      return (window.languages && window.languages.productFormAddToCart) || 'Add to bag';
    }
    function getSoldOutLabel() {
      return (window.languages && window.languages.productFormSoldOut) || 'Sold out';
    }
    function clearInlineState(btn) {
      ['opacity', 'pointer-events', 'cursor', 'filter'].forEach(p => btn.style.removeProperty(p));
    }

    function getBundleTotal() {
      let total = 0;
      Object.keys(selections).forEach(key => {
        const sel = selections[key];
        if (!sel) return;
        const amount = Number(sel.price);
        if (!isNaN(amount)) total += amount;
      });
      return total;
    }

    function renderATC() {
      if (!isCustomPackActive) return;

      const filled = Object.keys(selections).length;
      const isFull = filled === quantity;
      const pageAvailable = isPageVariantAvailable();
      const notifyBtn = getNotifyButton();

      document.body.classList.toggle('bundle-is-complete', isFull && pageAvailable);
      document.body.classList.toggle('cpb-page-sold-out', !pageAvailable);

      getAtcButtons().forEach(btn => {
        clearInlineState(btn);

        // Selected size is sold out → behave exactly like a normal sold-out
        // product: outlined "Sold out" button + Notify Me button.
        if (!pageAvailable) {
          btn.innerHTML = getSoldOutLabel();
          btn.setAttribute('disabled', 'disabled');
          btn.disabled = true;
          btn.removeAttribute('data-action');
          btn.classList.remove('Button--primary');
          btn.classList.add('Button--secondary');
          return;
        }

        btn.classList.remove('Button--secondary');
        btn.classList.add(btn.getAttribute('data-use-primary-button') === 'false' ? 'Button--secondary' : 'Button--primary');
        btn.setAttribute('data-action', 'add-to-cart');

        const label = isAdding ? 'Adding...' : getAddLabel();
        let html = `<span>${label}</span>`;
        // Price only appears once the bundle is complete (button enabled)
        if (isFull) {
          const total = getBundleTotal();
          if (total > 0) {
            html += `<span class="Button__SeparatorDot"></span><span class="cpb-bundle-total">${formatMoney(total)}</span>`;
          }
        }
        btn.innerHTML = html;

        if (isFull && !isAdding) {
          btn.removeAttribute('disabled');
          btn.disabled = false;
        } else {
          btn.setAttribute('disabled', 'disabled');
          btn.disabled = true;
        }
      });

      if (notifyBtn) {
        notifyBtn.style.display = pageAvailable ? 'none' : 'block';
        const pageId = window.currentProductData && window.currentProductData.id;
        if (!pageAvailable && pageId) notifyBtn.setAttribute('data-variant-id', pageId);
      }
    }

    // ==========================================
    // SHOW SLOTS
    // ==========================================
    function showSlots() {
      root.removeAttribute('hidden');
      root.style.cssText = 'display: block !important; visibility: visible !important; opacity: 1 !important;';
      isCustomPackActive = true;
      document.body.classList.add('custom-pack-active');
      updateCount();
    }

    function isCustomPackSwatch(el) {
      return !!(el && el.dataset && el.dataset.swatchType === 'custom_pack');
    }

    // Matches Shopify's own rounding for a per-item % discount: the
    // discount amount is floored to the nearest cent, THEN subtracted.
    function calcDiscountedPrice(originalPrice, discountPercent) {
      const originalCents = Math.round(Number(originalPrice) * 100);
      const discountCents = Math.floor(originalCents * (Number(discountPercent) || 0) / 100);
      return (originalCents - discountCents) / 100;
    }

    // ==========================================
    // AUTO SELECT DEFAULT PRODUCT (slot 1)
    // ==========================================
    // Only fills slot 1 with the page product if that size is in stock —
    // a sold-out variant in the bundle would make the whole cart add fail.
    function autoSelectFirstProduct() {
      const currentProd = window.currentProductData;
      if (!currentProd || !currentProd.id) return;

      // Never overwrite a product the shopper picked in the drawer
      if (selections[0] && !selections[0].auto) return;

      if (!isPageVariantAvailable()) {
        if (selections[0] && selections[0].auto) delete selections[0];
        return;
      }

      const basePrice = parseFloat(currentProd.price || 0);
      const discountPercent = getActivePackDiscountPercent();
      selections[0] = {
        id: currentProd.id,
        title: currentProd.title,
        image: currentProd.image,
        size: currentProd.size || currentSelectedSize || '',
        price: calcDiscountedPrice(basePrice, discountPercent),
        originalPrice: basePrice,
        auto: true
      };
    }

    function setQuantity(newQuantity) {
      if (!newQuantity || isNaN(newQuantity)) return;
      newQuantity = parseInt(newQuantity, 10);

      if (quantity !== newQuantity) {
        selections = {};
      }
      quantity = newQuantity;
      // Re-apply (or add) slot 1 with the new pack's discount %
      autoSelectFirstProduct();
      renderSlots();
      updatePricePerItem();
      // Pack changed — re-render drawer product prices with the new discount %
      if (currentCategoryHandle && currentProducts.length) renderDrawerProducts();
    }

    // Currently active pack's discount % (editable in the theme editor)
    function getActivePackDiscountPercent() {
      const activePackBtn = document.querySelector('[data-pack-option].pack-option--active');
      return activePackBtn
        ? (parseFloat(activePackBtn.getAttribute('data-discount-percent')) || 0)
        : 0;
    }

    // ==========================================
    // PRICE PER T-SHIRT (pack-tier based)
    // ==========================================
    // Averages the real discounted prices of the picked products; before
    // anything is picked, shows an estimate based on the page product.
    function updatePricePerItem() {
      if (!pricePerItemEl) return;
      if (!quantity) {
        pricePerItemEl.hidden = true;
        return;
      }

      const discountPercent = getActivePackDiscountPercent();
      const filledKeys = Object.keys(selections).filter(key => selections[key] && !isNaN(Number(selections[key].price)));

      let perItem;
      if (filledKeys.length) {
        const total = filledKeys.reduce((sum, key) => sum + Number(selections[key].price), 0);
        perItem = total / filledKeys.length;
      } else {
        const basePrice = (window.currentProductData && window.currentProductData.price)
          ? Number(window.currentProductData.price)
          : 0;
        if (!basePrice) {
          pricePerItemEl.hidden = true;
          return;
        }
        perItem = calcDiscountedPrice(basePrice, discountPercent);
      }

      pricePerItemEl.textContent = formatMoney(perItem) + ' /t-shirt';
      pricePerItemEl.hidden = false;
    }

    // ==========================================
    // RENDER SLOTS
    // ==========================================
    function renderSlots() {
      if (!grid) return;
      grid.innerHTML = '';

      for (let i = 0; i < quantity; i++) {
        const slot = document.createElement('button');
        slot.type = 'button';
        slot.className = 'cpb-slot';
        slot.dataset.index = i;

        const selected = selections[i];
        if (selected) {
          slot.classList.add('cpb-slot--filled');

          const removeBtn = document.createElement('span');
          removeBtn.className = 'remove-item';
          removeBtn.innerHTML = '&times;';
          removeBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            delete selections[i];
            renderSlots();
            updatePricePerItem();
          });
          slot.appendChild(removeBtn);

          const img = document.createElement('img');
          img.src = selected.image;
          img.alt = selected.title;
          slot.appendChild(img);

          const info = document.createElement('div');
          info.className = 'cpb-slot__info';
          if (selected.size) {
            const sizeEl = document.createElement('span');
            sizeEl.className = 'cpb-slot__size';
            sizeEl.textContent = selected.size;
            info.appendChild(sizeEl);
          }
          slot.appendChild(info);
        } else {
          const plus = document.createElement('span');
          plus.className = 'cpb-slot__plus';
          plus.textContent = '+';
          slot.appendChild(plus);
        }

        slot.addEventListener('click', function () {
          activeSlotIndex = i;
          openBundleDrawer();
        });

        grid.appendChild(slot);
      }
      updateCount();
    }

    // ==========================================
    // COUNT + ATC STATE
    // ==========================================
    function updateCount() {
      if (countEl) {
        countEl.textContent = Object.keys(selections).length + ' / ' + quantity;
      }
      renderATC();
    }

    // ==========================================
    // DRAWER: SIZE + CATEGORY + PRODUCTS
    // ==========================================
    const drawerSizeButtons   = drawerEl?.querySelectorAll('.drawer-size-btn');
    const drawerCategoryCards = drawerEl?.querySelectorAll('.drawer-cat-card');
    const drawerSizeText      = document.getElementById('drawer-selected-size-text');
    const drawerCatText       = document.getElementById('drawer-selected-cat-text');
    const drawerProductsBox   = document.getElementById('drawer-products-container');

    drawerSizeButtons?.forEach(btn => {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('sold-out')) return;
        drawerSizeButtons.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        currentSelectedSize = btn.dataset.size;
        if (drawerSizeText) drawerSizeText.textContent = currentSelectedSize;
        if (currentCategoryHandle) renderDrawerProducts();
      });
    });

    drawerCategoryCards?.forEach(card => {
      card.addEventListener('click', function () {
        drawerCategoryCards.forEach(c => c.classList.remove('active'));
        card.classList.add('active');
        currentCategoryHandle = card.dataset.handle;
        if (drawerCatText) drawerCatText.textContent = card.dataset.title;
        fetchCollectionProducts(currentCategoryHandle);
      });
    });

    // Default-select the first category so products load automatically
    if (drawerCategoryCards && drawerCategoryCards.length > 0) {
      const firstCategoryCard = drawerCategoryCards[0];
      firstCategoryCard.classList.add('active');
      currentCategoryHandle = firstCategoryCard.dataset.handle;
      if (drawerCatText) drawerCatText.textContent = firstCategoryCard.dataset.title;
      fetchCollectionProducts(currentCategoryHandle);
    }

    function fetchCollectionProducts(handle) {
      if (!drawerProductsBox) return;
      drawerProductsBox.innerHTML = '<p class="drawer-loading-text">Loading products...</p>';
      fetch(`/collections/${handle}/products.json?limit=250`)
        .then(res => res.json())
        .then(data => {
          currentProducts = data.products || [];
          renderDrawerProducts();
        })
        .catch(() => {
          drawerProductsBox.innerHTML = '<p class="drawer-loading-text">Error loading products.</p>';
        });
    }

    function renderDrawerProducts() {
      if (!drawerProductsBox) return;
      if (!currentSelectedSize) {
        drawerProductsBox.innerHTML = '<p class="drawer-loading-text">Please select a size to view products.</p>';
        return;
      }
      if (!currentProducts.length) {
        drawerProductsBox.innerHTML = '<p class="drawer-loading-text">No products in this category.</p>';
        return;
      }

      const cards = [];
      currentProducts.forEach(product => {
        const matchingVariant = product.variants.find(v =>
          v.option1 === currentSelectedSize ||
          v.option2 === currentSelectedSize ||
          v.option3 === currentSelectedSize
        );
        // Show every product regardless of stock in the selected size — the
        // ADD button is what gets disabled when it's not purchasable.
        const variant = matchingVariant || product.variants[0];
        if (!variant) return;
        const inStockForSize = !!(matchingVariant && matchingVariant.available);

        let images = (product.images || []).map(img => img.src).filter(Boolean);
        if (!images.length) {
          const fallbackImg = variant.featured_image?.src || '';
          if (fallbackImg) images = [fallbackImg];
        }
        const originalPrice = parseFloat(variant.price);
        cards.push({ product, variant, images, originalPrice, inStockForSize });
      });

      if (!cards.length) {
        drawerProductsBox.innerHTML = `<p class="drawer-loading-text">No products in this category.</p>`;
        return;
      }

      const discountPercent = getActivePackDiscountPercent();

      drawerProductsBox.innerHTML = '';
      cards.forEach(({ product, variant, images, originalPrice, inStockForSize }) => {
        const card = document.createElement('div');
        card.className = 'drawer-product-card' + (inStockForSize ? '' : ' drawer-product-card--oos');

        const discountedPrice = calcDiscountedPrice(originalPrice, discountPercent);
        const priceHtml = discountPercent > 0
          ? `<span class="drawer-price-compare">${formatMoney(originalPrice)}</span> / <span class="drawer-price-final">${formatMoney(discountedPrice)}</span>`
          : `<span class="drawer-price-final">${formatMoney(originalPrice)}</span>`;

        const sliderImagesHtml = images.map((src, i) =>
          `<img src="${src}" alt="${product.title}" class="drawer-slider-img"${i === 0 ? '' : ' hidden'} data-index="${i}">`
        ).join('');

        const arrowsHtml = images.length > 1
          ? `<button type="button" class="drawer-slider-arrow drawer-slider-prev" aria-label="Previous image">&#8249;</button>
             <button type="button" class="drawer-slider-arrow drawer-slider-next" aria-label="Next image">&#8250;</button>`
          : '';

        const oosNoteHtml = inStockForSize
          ? ''
          : `<div class="drawer-product-oos-note">Out of stock in ${currentSelectedSize}</div>`;

        card.innerHTML = `
          <div class="drawer-product-media">
            ${sliderImagesHtml}
            ${arrowsHtml}
          </div>
          <div class="drawer-product-title">${product.title}</div>
          <div class="drawer-product-price">${priceHtml}</div>
          ${oosNoteHtml}
          <button class="drawer-add-btn"${inStockForSize ? '' : ' disabled'} type="button">${inStockForSize ? 'ADD' : 'OUT OF STOCK'}</button>
        `;

        if (images.length > 1) {
          let activeIndex = 0;
          const slideImgs = card.querySelectorAll('.drawer-slider-img');
          const showSlide = (newIndex) => {
            slideImgs[activeIndex].hidden = true;
            activeIndex = (newIndex + slideImgs.length) % slideImgs.length;
            slideImgs[activeIndex].hidden = false;
          };
          card.querySelector('.drawer-slider-prev').addEventListener('click', function (e) {
            e.stopPropagation();
            showSlide(activeIndex - 1);
          });
          card.querySelector('.drawer-slider-next').addEventListener('click', function (e) {
            e.stopPropagation();
            showSlide(activeIndex + 1);
          });
        }

        card.querySelector('.drawer-product-media').addEventListener('click', function () {
          openImageViewer(product.title, images);
        });

        if (inStockForSize) {
          card.querySelector('.drawer-add-btn').addEventListener('click', function () {
            addProductToActiveSlot({
              id: variant.id,
              title: product.title,
              image: images[0] || '',
              size: currentSelectedSize,
              price: discountedPrice,
              originalPrice: originalPrice
            });
          });
        }
        drawerProductsBox.appendChild(card);
      });
    }

    function addProductToActiveSlot(prod) {
      if (activeSlotIndex === null || activeSlotIndex === undefined) {
        for (let i = 0; i < quantity; i++) {
          if (!selections[i]) { activeSlotIndex = i; break; }
        }
      }
      if (activeSlotIndex === null || activeSlotIndex === undefined) return;
      selections[activeSlotIndex] = prod;
      renderSlots();
      updatePricePerItem();
      activeSlotIndex = null;
      closeBundleDrawer();
    }

    // ==========================================
    // ATC INTERCEPT (window-level capture, main product form only)
    // ==========================================
    function getMainAtcFromEvent(e) {
      const btn = e.target.closest?.(ATC_SELECTOR);
      return btn && productForm.contains(btn) ? btn : null;
    }

    window.addEventListener('click', function (e) {
      const atcBtn = getMainAtcFromEvent(e);
      if (!atcBtn) return;
      if (!isCustomPackActive) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (!isPageVariantAvailable() || isAdding) return false;

      const filled = Object.keys(selections).length;
      if (filled < quantity) {
        grid?.classList.remove('cpb-shake');
        void grid?.offsetWidth;
        grid?.classList.add('cpb-shake');
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }

      addBundleToCart();
      return false;
    }, true);

    window.addEventListener('submit', function (e) {
      const form = e.target;
      if (form !== productForm) return;
      if (!isCustomPackActive) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (!isPageVariantAvailable() || isAdding) return false;
      if (Object.keys(selections).length === quantity) addBundleToCart();
      return false;
    }, true);

    function addBundleToCart() {
      const bundleId = 'bundle-' + Date.now();
      const items = [];
      for (let i = 0; i < quantity; i++) {
        const sel = selections[i];
        if (!sel || !sel.id) continue;
        items.push({
          id: sel.id,
          quantity: 1,
          properties: {
            'Bundle Size': sel.size || '',
            '_bundle_id': bundleId
          }
        });
      }
      if (!items.length) return;

      isAdding = true;
      renderATC();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items })
      })
        .then(res => res.json())
        .then(data => {
          if (data.status && data.status !== 200) {
            throw new Error(data.description || 'Add to cart failed');
          }
          // Theme's own event — re-renders the cart and opens the drawer
          document.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: data.items ? data.items[0] : null,
              quantity: items.length
            }
          }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:added', { bubbles: true, detail: data }));

          isAdding = false;
          renderATC();
        })
        .catch(err => {
          console.error('CPB: Bundle add error:', err);
          isAdding = false;
          getAtcButtons().forEach(btn => {
            const label = btn.querySelector('span');
            if (label) label.textContent = 'Try again';
          });
          setTimeout(renderATC, 1500);
        });
    }

    // ==========================================
    // SWATCH + PACK CLICK LISTENERS
    // ==========================================
    function getActivePackQuantity() {
      const activePackBtn = document.querySelector('[data-pack-option].pack-option--active');
      const q = activePackBtn ? (activePackBtn.getAttribute('data-quantity') || activePackBtn.dataset.packKey) : '10';
      const match = String(q).match(/\d+/);
      return match ? match[0] : 10;
    }

    document.addEventListener('click', function (e) {
      const swatchBtn = e.target.closest('[data-color-pack-option]');
      if (swatchBtn && isCustomPackSwatch(swatchBtn)) {
        showSlots();
        setQuantity(getActivePackQuantity());
      }

      const packBtn = e.target.closest('[data-pack-option]');
      if (packBtn) {
        document.querySelectorAll('[data-pack-option]').forEach(function (b) {
          b.classList.remove('pack-option--active');
        });
        packBtn.classList.add('pack-option--active');

        const q = packBtn.getAttribute('data-quantity') || packBtn.dataset.packKey;
        const match = String(q).match(/\d+/);
        if (match) setQuantity(match[0]);
      }
    });

    // ==========================================
    // SYNC WITH MAIN PRODUCT SIZE SELECTOR
    // ==========================================
    function applyVariantChange(newVariant) {
      if (!newVariant) return;

      const previousId = window.currentProductData ? window.currentProductData.id : null;
      const priceMajor = Number(newVariant.price) / 100;

      window.currentProductData = {
        id: newVariant.id,
        title: (window.currentProductData && window.currentProductData.title) || '',
        image: newVariant.featured_image ? newVariant.featured_image.src : ((window.currentProductData && window.currentProductData.image) || ''),
        price: priceMajor,
        size: newVariant.option1 || newVariant.option2 || newVariant.option3 || '',
        available: !!newVariant.available
      };

      if (previousId !== newVariant.id) {
        // Only touches slot 1 if it's empty or still the auto-filled product
        autoSelectFirstProduct();
        renderSlots();
        updatePricePerItem();
        if (currentCategoryHandle && currentProducts.length) renderDrawerProducts();
      }

      // Always re-render the button: the theme just rewrote its innerHTML
      renderATC();
    }

    // The theme fires "variant:changed" right AFTER it has rewritten the ATC
    // button and Notify button, so re-applying our state here always wins.
    document.addEventListener('variant:changed', function (e) {
      if (!isCustomPackActive) return;
      if (!productSection.contains(e.target)) return;
      applyVariantChange(e.detail && e.detail.variant);
    });

    // Fallback: resolve the variant straight from the size radios, in case
    // the theme's "variant:changed" event doesn't reach us. Runs on the next
    // tick so the theme's own button/Notify update has already happened.
    function getVariantFromSelectors() {
      if (!window.cpbProductVariants || !window.cpbProductVariants.length) return null;
      const variantSelectionEl = productForm.querySelector('#variant_selection');
      if (!variantSelectionEl) return null;

      const selectedByPosition = {};
      variantSelectionEl.querySelectorAll('input[type="radio"]:checked').forEach(function (radio) {
        const pos = parseInt(radio.getAttribute('data-option-position'), 10);
        if (!isNaN(pos)) selectedByPosition[pos] = radio.value;
      });
      if (!Object.keys(selectedByPosition).length) return null;

      return window.cpbProductVariants.find(function (v) {
        if (selectedByPosition[1] !== undefined && v.option1 !== selectedByPosition[1]) return false;
        if (selectedByPosition[2] !== undefined && v.option2 !== selectedByPosition[2]) return false;
        if (selectedByPosition[3] !== undefined && v.option3 !== selectedByPosition[3]) return false;
        return true;
      }) || null;
    }

    productForm.addEventListener('change', function (e) {
      if (!isCustomPackActive) return;
      if (!e.target.closest || !e.target.closest('#variant_selection')) return;
      setTimeout(function () {
        applyVariantChange(getVariantFromSelectors());
      }, 0);
    });

    // ==========================================
    // INITIAL STATE
    // ==========================================
    if (window.currentProductData && window.currentProductData.available === undefined) {
      const v = findVariantById(window.currentProductData.id);
      if (v) window.currentProductData.available = !!v.available;
    }

    autoSelectFirstProduct();
    renderSlots();

    const activeSwatch = document.querySelector('[data-color-pack-option].color-pack-option--active');
    if (isCustomPackSwatch(activeSwatch)) {
      document.body.classList.add('custom-pack-active');
      isCustomPackActive = true;
      setQuantity(getActivePackQuantity());
    }

    updatePricePerItem();
  }

  // Init runs LAST — after moneyFormat and every helper above is defined.
  // (With `defer`, the DOM is already parsed when this file executes, so
  // ready() fires immediately; calling it at the top of the file ran the
  // builder before moneyFormat existed and crashed the whole script.)
  ready(function () {
    document.querySelectorAll('[data-custom-pack-builder]').forEach(function (el) {
      // Idempotency guard — never init the same element twice
      if (el.dataset.cpbInitialized === '1') return;
      el.dataset.cpbInitialized = '1';
      try {
        initBuilder(el);
      } catch (err) {
        console.error('CPB: init error', err);
      }
    });
  });
})();